import {ChangeDetectionStrategy, Component, Input} from '@angular/core'

@Component({
  selector: 'bgo-hero-call-to-action-section',
  templateUrl: './hero-call-to-action-section.component.html',
  styles: [':host { display: block; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeroCallToActionSectionComponent {
  @Input() title?: string
}
